var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.subscribed)?_c('div',[_vm._t("form",null,{"subscription":_vm.subscription,"subscribe":_vm.subscribe,"error":_vm.error}),_vm._v(" "),_c('VueRecaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.sitekey,"size":"invisible"},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})],2):_vm._t("thank-you")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }